import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
// 引入 i18n 配置
import i18n, { loadLocaleMessages } from './lang'
import { registerGlobComp } from '@/components/registerGlobComp'
import './style.css' // 导入 Tailwind CSS
import 'normalize.css' // 导入重置样式
import '@/styles/global.less' // 导入全局样式
import '@/assets/styles/fonts.css' // 导入字体样式

const app = createApp(App)
const pinia = createPinia()

app.use(registerGlobComp)
app.use(pinia)
app.use(router)
app.use(i18n) // 注册 i18n
loadLocaleMessages() // 加载后端多语言配置
app.mount('#app')
